import Text from './Text'
import styled from 'styled-components'

const Input = styled(Text)`
  ${props => (props.error ? `border: ${props.theme.borders.red};` : '')}
  ::placeholder {
    color: ${props => props.theme.colors.grey.cool};
  }
  ::focus {
    box-shadow: ${props => props.theme.shadows[2]};
  }
`

Input.defaultProps = {
  as: 'input',
  fontSize: 's',
  height: 3,
  width: 1,
  borderRadius: 1,
  border: 'grey.2'
}

export default Input
